/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index visually-hidden to autogenerate all the components and extensions
 * Used by "prepareVisuallyHiddens"
 */

import VisuallyHidden from './visually-hidden/VisuallyHidden'
export * from './visually-hidden/VisuallyHidden'
export default VisuallyHidden
